import BaseUseCase from "../../base_use_case.js.jsx";

class InvestmentConfirmationUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/projects/investment_steps/confirmation`,
      data: this.wrapParams(params, "investment"),
    });
  }
}

const instance = new InvestmentConfirmationUseCase();
export default instance;